import React from 'react';
import logo from './logo.svg';
// import './App.css';

import { Component } from 'react'
import workerScript from './Worker'
 
import { AuthProvider, useAuth } from './AuthContext';
import { type } from 'os';


type TUser = {
  isLoggedIn: Boolean;
  userid: string;
  username: string;
  userlevel: string;
}
type TAuthContext = {
  user: TUser;
  logginin: boolean;
  login: Function;
  logout: Function;
  signin: Function;
}

interface IIUser {
  isLoggedIn: Boolean;
  userid: string;
  username: string;
  userlevel: string;
}
interface IAuthContext {
  user: IUser;
  logginin: boolean;
  login: Function;
  logout: Function;
  signin: Function;
}

interface IUser {
  [index: string]: string | boolean | number;
}


function App() {
  const [extmessage, setExtmessage] = React.useState("")
  const auth = useAuth()
  const [user, setUser] = React.useState<IUser>() 

  function btnGettinStarted(){
    auth.login("tstylian", "pass")
  }

  console.log("App, auth", auth)

  React.useEffect( () =>{
    // setUser( auth.user)
    setUser( {
      isLoggedIn: true,
      userid: "1",
      username: "gstylianop",
      userlevel: "moderate"} )
  },[auth.user])


  console.log('App user', user)
  return (

    <div className="App">

    <header className="primary-header">
    <div className="container">
      <div className="nav-wrapper">
      <a href="#"><img src="./images/react_logo.svg" alt="Manage" /></a>
        <button className="mobile-nav-toggle" aria-controls="primary-navigation" aria-expanded="false">
          <img className="icon-hamburger" src="images/icon-hamburger.svg" alt="" aria-hidden="true" />
          <img className="icon-close" src="images/icon-close.svg" alt="" aria-hidden="true" />
          <span className="visually-hidden">Menu</span>
        </button>
        <nav className="primary-navigation" id="primary-navigation">
          <ul aria-label="Primary" role="list" className="nav-list">
            <li><a href="#">Projects</a></li>
            <li><a href="#">About Me</a></li>
            <li><a href="#">Career</a></li>
            <li><a href="#">Community</a></li>
            <li><a href="/">Back to Start</a></li>
          </ul>
        </nav>
        <button onClick={(e)=>{btnGettinStarted()}} className="button | display-sm-none display-md-inline-flex">Get Started</button>
      </div>
    </div>
   </header>


  {user && user.isLoggedIn===true && <div className="main-container">
    <main className="testimonial-grid">
      <article className="testimonial grid-col-span-2 flow bg-primary-400 quote text-neutral-100">
        <div className="flex">
          <div>
            <img  src="./images/react_logo.svg" alt="Reac JS" />
          </div>
          <div>
            <h2 className="name">Reac JS</h2>
            <p className="position">React JSX - Javascript </p>
          </div>
        </div>
        <p>
        JSX is a syntax extension for JavaScript that lets you write HTML-like markup inside a JavaScript file.
        Although there are other ways to write components, most React developers prefer the conciseness of JSX, and most codebases use it.
        </p>
        <p>
          “ The Web has been built on HTML, CSS, and JavaScript. For many years, web developers kept content in HTML, design in CSS, and logic in JavaScript—often in separate files! Content was marked up inside HTML while the page’s logic lived separately in JavaScript.
          But as the Web became more interactive, logic increasingly determined content. JavaScript was in charge of the HTML! This is why in React, rendering logic and markup live together in the same place—components. ”
        </p>
      </article>
      <article className="testimonial flow bg-secondary-400 text-neutral-100">
        <div className="flex">
          <div>
            <img src="./images/kewin_powell.jpg" alt="Kevin Powell" />
          </div>
          <div>
            <h2 className="name">Kevin Powell</h2>
            <p className="position">Verified Specialist</p>
          </div>
        </div>
        <p>
        Youtube (learn from free). Weekly front-end web development & design tips, tricks, and tutorials.
        </p>
        <p>
          “ I teach people how to make the web and how to make it look good while they're at it. ”
        </p>
      </article>
      <article className="testimonial flow bg-neutral-100 text-secondary-400">
        <div className="flex">
          <div>
            <img src="./images/java.png" alt="java" />
          </div>
          <div>
            <h2 className="name">Java</h2>
            <p className="position">programming language and computing platform</p>
          </div>
        </div>
        <p>
        Running more than 60 billion Java Virtual Machines worldwide.
        </p>
        <p>
          “ Java is a programming language and computing platform first released by Sun Microsystems in 1995. It has evolved from humble beginnings to power a large share of today’s digital world, by providing the reliable platform upon which many services and applications are built. New, innovative products and digital services designed for the future continue to rely on Java, as well ”
        </p>
      </article>
      <article className="testimonial grid-col-span-2 flow bg-secondary-500 text-neutral-100">
        <div className="flex">
          <div>
            <img className="border-primary-400" src="./images/social-icons.svg" alt="Data mining" />
          </div>
          <div>
            <h2 className="name">Data Mining</h2>
            <p className="position">mining, clustering and big data</p>
          </div>
        </div>
        <p>
        Data mining, Data clustering, Data manipulation.
        </p>
        <p>
          “ Data mining is most commonly defined as the process of using computers and automation to search large sets of data for patterns and trends, turning those findings into business insights and predictions. ”
        </p>
      </article>
      <article className="testimonial flow bg-neutral-100 text-secondary-400">
        <div className="flex">
          <div>
            <img src="./images/gstylianopoulos_profile_112.jpg" alt="George Stylianopoulos" />
          </div>
          <div>
            <h2 className="name">George Stylianopoulos</h2>
            <p className="position">Under Graduate</p>
          </div>
        </div>
        <p>
          dit.uop.gr: Such a life-changing experience. Highly recommended!
        </p>
        <p>
          “ Before joining the school, I’ve never written a line of code. I needed some structure from
          professionals who can help me learn programming step by step. I was encouraged to enroll by my teachers 
          who can only say wonderful things about programming. 
          It certainly helped me to focus for jobs as a full-stack developer.
          100% recommend! ”
        </p>
      </article>
    </main>

    </div>}

  {!user || user.isLoggedIn!==true && <div className="main-container">
    <h5>Click on "Getting started: button to &lt;&lt;&nbsp; login &nbsp;&gt;&gt; and find more about me </h5>
  </div>}

  </div>

 

  );
}

export default App;


